module.exports = __webpack_public_path__ + "media/images/gallery/constellations/equuleus/equ_rn-355ba0c52f7e852d2f55fe42762f257a.gif";